import { Container, ShowFor, Size } from "@brightagency/headstart-common";
import React, { useRef } from "react";
import { WPPost } from "../../../constants/types";
import { ListingAcf } from "../../../constants/types/acf";
import { useListingSorters, useSuburbName } from "../../../utils";
import { SortButton } from "../../atoms/SortButton";
import { CarouselControls } from "../../molecules/CarouselControls";
import { ListingCard } from "../../molecules/ListingCard";
import { useListingCardCarouselSize } from "../../molecules/ListingCard/services";
import { SkeletonCard } from "../../molecules/SkeletonCard";
import { Carousel, usePagedHorizontalScrolling } from "../Carousel";
import { Skeleton } from "../RelatedLocalServices/Skeleton";
import { Outer, Inner, Title, TitleSecondarySection, SortButtonWrapper, TextContent, SubTitle } from "./styled";

interface Props {
    title: string;
    subTitle: string;
    listings: WPPost<ListingAcf>[];
    usingLocation: boolean;
    onToggleUsingLocation: () => void;
}

export const HeroAssessmentResults: React.FC<Props> = props => {
    const trackRef = useRef<HTMLDivElement>(null);
    const { itemWidth, itemGutter, totalItemWidth } = useListingCardCarouselSize();
    const { scrollLeft, scrollRight } = usePagedHorizontalScrolling({
        trackRef,
        pageWidth: totalItemWidth,
        contentCount: props.listings?.length ?? 0,
    });
    const { locationSort, nameSort } = useListingSorters();
    const suburbName = useSuburbName();
    const listings = props.listings ?? [];
    const sortedListing = listings.sort(props.usingLocation ? locationSort : nameSort);
    
    return (
        <Outer hasListings={true}>
            <Container>
                <Title>{props.title}</Title>
            </Container>
            <Container className="mobile-no-padding-right">
                <Inner>
                    <TitleSecondarySection>
                        <SortButtonWrapper>
                            <SortButton appearance="light" filter={true} />
                        </SortButtonWrapper>
                        <ShowFor size={Size.large}>
                            <CarouselControls
                                reverseButtons
                                onLeftClick={scrollLeft}
                                onRightClick={scrollRight}
                            />
                        </ShowFor>
                    </TitleSecondarySection>
                </Inner>
            </Container>
            <Container>
                <TextContent>
                    <SubTitle>{props.subTitle} {suburbName}</SubTitle>
                </TextContent>
            </Container>
                <Carousel scrollingRef={trackRef} itemWidth={itemWidth} itemGutter={itemGutter}>
                    {sortedListing && sortedListing.length === 0 ?
                        Array(3)
                            .fill(1)
                            .map(() => <SkeletonCard key={1} />)
                    :  sortedListing.length > 0 ?
                        sortedListing.map(listing => <ListingCard key={listing.id} listing={listing} compact={false} />)
                    :  <Skeleton />
                    }
                </Carousel>
        </Outer>
    );
};